export default __webpack_public_path__ + "static/media/award_icon.552d0e86.svg";